// extracted by mini-css-extract-plugin
export default {"container":"ho-z","brandName":"io-z","productName":"jo-z","productNamePdpEnhancements":"ko-z","breakLongProductName":"lo-z"};